import * as system from 'durandal/system';

import * as userService from '@/legacy/services/user';
import * as verificationService from '@/legacy/services/verification/verification';
import * as plootoUtils from '@/legacy/utils/plooto';
import * as viewModels from '@/legacy/viewmodels/viewModels';

const API_PREFIX = 'v1';

export enum AccountVerificationStatus {
  Pending = 0,
  PinPending,
  PinSent,
  PinFailed,
  UploadRequired,
  Completed,
  Processing,
}
export class AccountVerificationResult {
  public status: AccountVerificationStatus;

  public accountId: string;

  public priority: boolean;

  public currency: string;

  public microDepositStatus: string;

  public microDepositError: string;

  public displayName: string;

  public maskedAccountNumber: string;
}

export class VerificationUserService {
  public VerifyIdentity(formData: FormData): JQueryPromise<verificationService.VerificationStatus> {
    return system
      .defer<verificationService.VerificationStatus>((dfd) => {
        userService.Instance.AuthorizedUpload(
          `${import.meta.env.APP_URLS_API_URL}/${API_PREFIX}/users/verification`,
          formData
        )
          .done((verificationInfo: verificationService.VerificationStatus) => {
            if (plootoUtils.IsNullOrUndefined(verificationInfo) || verificationInfo.error) {
              dfd.reject(verificationInfo);
              return;
            }
            dfd.resolve(verificationInfo);
          })
          .fail((verificationInfo: verificationService.VerificationStatus) => {
            dfd.reject(verificationInfo);
          });
      })
      .promise();
  }

  public PostIdentityPersonalInformation(
    personalInformation: verificationService.PersonalInformationBindingModel
  ): JQueryPromise<any> {
    return system
      .defer((dfd) => {
        userService.Instance.AuthorizedPost(
          `${
            import.meta.env.APP_URLS_API_URL
          }/${API_PREFIX}/users/verification/personalInformation`,
          personalInformation
        )
          .done((verificationInfo: verificationService.VerificationStatus) => {
            if (plootoUtils.IsNullOrUndefined(verificationInfo) || verificationInfo.error) {
              dfd.reject(verificationInfo);
              return;
            }
            dfd.resolve(verificationInfo);
          })
          .fail((verificationInfo: verificationService.VerificationStatus) => {
            dfd.reject(verificationInfo);
          });
      })
      .promise();
  }

  public PostIdentityAddressInformation(
    addressInformation: verificationService.AddressInformationBindingModel
  ): JQueryPromise<viewModels.PersonalIdentityVerificationQuestionSetViewModel> {
    return system
      .defer<viewModels.PersonalIdentityVerificationQuestionSetViewModel>((dfd) => {
        userService.Instance.AuthorizedPost(
          `${import.meta.env.APP_URLS_API_URL}/${API_PREFIX}/users/verification/addressInformation`,
          addressInformation
        )
          .done((verificationInfo: verificationService.VerificationStatus) => {
            if (plootoUtils.IsNullOrUndefined(verificationInfo) || verificationInfo.error) {
              dfd.reject(verificationInfo);
              return;
            }
            dfd.resolve(verificationInfo as any);
          })
          .fail((verificationInfo: verificationService.VerificationStatus) => {
            dfd.reject(verificationInfo);
          });
      })
      .promise();
  }

  public GetVerifyIdentityStatus(
    companyId: string,
    userId: string
  ): JQueryPromise<verificationService.VerificationStatusIdentityViewModel> {
    return system
      .defer<verificationService.VerificationStatusIdentityViewModel>((dfd) => {
        userService.Instance.AuthorizedGet(
          `${
            import.meta.env.APP_URLS_API_URL
          }/${API_PREFIX}/companies/${companyId}/verification/users/${userId}/status`
        )
          .then((verificationInfo) => {
            if (plootoUtils.IsNullOrUndefined(verificationInfo) || verificationInfo.error) {
              dfd.reject(verificationInfo);
              return;
            }
            dfd.resolve(verificationInfo);
          })
          .fail((error) => {
            dfd.reject(error);
          });
      })
      .promise();
  }

  public GetAccountVerificationStatus(companyId): JQueryPromise<Array<AccountVerificationResult>> {
    return system
      .defer<Array<AccountVerificationResult>>((dfd) => {
        userService.Instance.AuthorizedGet(
          `${
            import.meta.env.APP_URLS_API_URL
          }/${API_PREFIX}/companies/${companyId}/verification/accounts`
        )
          .then((accountVerificationStatus: any) => {
            if (
              plootoUtils.IsNullOrUndefined(accountVerificationStatus) ||
              accountVerificationStatus.error
            ) {
              dfd.reject(accountVerificationStatus);
              return;
            }
            dfd.resolve(accountVerificationStatus);
          })
          .fail((accountVerificationStatus) => {
            dfd.reject(accountVerificationStatus);
          });
      })
      .promise();
  }
}
export const Instance = new VerificationUserService();
